import React from 'react'
import NumberFormat, {
  NumberFormatValues,
  SourceInfo,
} from 'react-number-format'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa6'

interface CustomCurrencyInputProps {
  disabled?: boolean
  label?: string
  decimals?: number
  value: number | undefined
  prefix?: string
  suffix?: string
  step?: number
  min?: number
  max?: number
  placeholder?: string
  onChange: (value: number | undefined) => void

  testId?: string

  width?: string
  margin?: string
}

const CustomCurrencyInput: React.FC<CustomCurrencyInputProps> = ({
  disabled,
  label,
  decimals,
  value,
  prefix,
  suffix,
  placeholder,
  step,
  min,
  max,
  onChange,
  testId,
  width,
  margin,
}) => {
  const onChangeWrapper = (values: NumberFormatValues, _: SourceInfo) => {
    onChange(values.floatValue)
  }

  const onStepUp = () => {
    if (value !== undefined && step) {
      if (max && value + step > max) {
        return
      }
      onChange(value + step)
    }
  }

  const onStepDown = () => {
    if (value !== undefined && step && value - step >= 0) {
      if (min && value - step < min) {
        return
      }
      onChange(value - step)
    }
  }

  return (
    <div style={{ width, margin }} className="custom-currency-input-container">
      <label className="text-sm font-bold">{label}</label>
      <div className="w-full">
        <NumberFormat
          id={testId}
          disabled={disabled}
          value={value !== undefined ? value : ''}
          placeholder={placeholder}
          decimalScale={decimals}
          fixedDecimalScale={true}
          prefix={prefix}
          suffix={suffix}
          step={step}
          min={min}
          max={max}
          onValueChange={onChangeWrapper}
          className="custom-currency-input"
        />
        {step && !disabled && (
          <div className="step-container">
            <button onClick={onStepUp}>
              <FaChevronUp />
            </button>
            <button onClick={onStepDown}>
              <FaChevronDown />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomCurrencyInput
